'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useRouter } from '@flipster/i18n/routing';
import { Spinner } from '@flipster/react/design-system/spinner';
import { center, vstack } from '@flipster/styled-system/patterns';
import { checkAxiosError } from '@flipster/utils/axios';
import { getErrorCode } from '@flipster/utils/error';
import { EarnEvent } from '@flipster/utils/segment/events/earn';

import { SegmentPage } from '../misc/segment/segment-page';
import HeroSection from './components/HeroSection';
import JoinButton from './components/JoinButton';
import MissionsSection from './components/MissionsSection';
import PoolHeader from './components/PoolHeader';
import PoolInfoCard from './components/PoolInfoCard';
import { userPoolBunja } from './user-pool.state';

const NewUserLaunchpool = () => {
  const router = useRouter();
  const { userPoolIsLoadingAtom, userPoolErrorAtom, userPoolDataAtom } = useBunja(userPoolBunja);
  const userPoolError = useAtomValue(userPoolErrorAtom);
  const isLoading = useAtomValue(userPoolIsLoadingAtom);
  const userPoolData = useAtomValue(userPoolDataAtom);
  useEffect(() => {
    if (checkAxiosError(userPoolError)) {
      const errorCode = getErrorCode(userPoolError);
      if (errorCode === 'api.userpool.notFound') router.push('/404');
    }
  }, [router, userPoolError]);

  return (
    <>
      <SegmentPage name={EarnEvent.EarnTabViewNewJoinerPool} />
      <div
        className={vstack({
          maxW: 960,
          mx: 'auto',
          p: {
            base: 16,
            tablet: 24,
          },
          pb: {
            base: 56,
            tablet: 150,
          },
        })}
      >
        {isLoading ? (
          <div className={center({ w: '100%', h: '100vh' })}>
            <Spinner />
          </div>
        ) : (
          <>
            <div className={vstack({ gap: 12 })}>
              <PoolHeader />

              <HeroSection />
            </div>

            <div className={vstack({ gap: 16, mt: 40, w: '100%' })}>
              <JoinButton />
              <PoolInfoCard />
              {userPoolData?.joined && <MissionsSection />}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default NewUserLaunchpool;
